import routerTree from './routerTree'

//获取根据后台权限，生成权限列表

//遍历权限树
let user_permissions = [] //存储用户权限id列表
let arrList = [] //存储用户权限列表
function getMeus(permissions, type = 1) {
	arrList = []
	//type==1获取权限树，type==2获取权限数组
	user_permissions = permissions
	let arrTree = JSON.parse(JSON.stringify(routerTree));
	//进行权限树筛选，不包含的权限进行删除
	for (let i = 0; i < arrTree.length; i++) {
		if (!judgeCorrect(arrTree[i])) {
			arrTree.splice(i, 1);
			--i;
		}
	}

	if (type === 2) {
		return arrList
	}

	return arrTree
}

//判断是否有权限
function judgeCorrect(item) {
	if (item.children) {
		for (let j = 0; j < item.children.length; j++) {
			if (!judgeCorrect(item.children[j])) {
				item.children.splice(j, 1);
				--j;
			}
		}
		//子元素不存在了，删除当前分组
		if (item.children.length <= 0) {
			return false
		}
		return true
	} else {
		if (user_permissions[0] == 'all') {
			//最高权限账号
			if (item.path && !arrList.includes(item)) {
				arrList.push(item)
			}
			if (item.hidden) {
				return false
			}
			return true
		} else {
			// 其他账号
			let flag = user_permissions.includes(item.id)
			//获取权限数组
			if (flag && item.path && !arrList.includes(item)) {
				arrList.push(item)
			}
			//隐藏页面，不加入菜单中
			if (flag && item.hidden) {
				return false
			}
			return flag

		}
	}
}
export default getMeus
